import GameShow from '../components/Game/GameShow/GameShow';

const GameShowPage = () => {
	return <GameShow />;
};

export default GameShowPage;
